const httpError = ({
  statusCode,
  logMessage,
  displayMessage,
  stackTrace = {},
  log,
}) => {
  const error = new Error(logMessage);
  error.statusCode = statusCode;
  error.displayMessage = displayMessage;
  error.stackTrace = stackTrace;

  log.error({
    statusCode,
    logMessage,
    displayMessage,
    stackTrace,
  });

  return error;
};

const isHandledError = (error = {}) => !!error.statusCode;

const routeError = (err = {}, log) => (
  isHandledError(err) ? err : (
    httpError({
      statusCode: 500,
      logMessage: err.message,
      displayMessage: 'Oops, something went wrong',
      stackTrace: err.stack,
      log,
    })
  )
);

export {
  httpError,
  isHandledError,
  routeError,
};
